import styled from 'styled-components';

export const InputContainer = styled.div`
  pointer-events: none;
`;

export const Container = styled.div`
  position: relative;
`;

export const OptionsContainer = styled.div`
  display: flex;
`;

export const RelativeColumn = styled.div`
  position: relative;
  flex: 1;
`;
